export default __webpack_public_path__ + "static/media/im logo.569c6c6d.jpg";